import { Doc } from '@dadohr/shared/domainTypes/document';
import { IExperience, IExperienceTemplate } from '@dadohr/shared/domainTypes/experience';
import { AssigneeBouncedErrorData, ErroDataType } from '@dadohr/shared/domainTypes/instance';
import { compact } from 'lodash';
import { getItemDisplayName, resolveExpTitle } from '../../../../helpers/adminName';
import {
  getMessageTemplateById,
  getTaskTemplateById
} from '../../../../../../services/experiences/template';
import type { AssigneeBounceErrorData } from '../../InstanceProblems';

// Mirrors `getIssueTitleText`'s ASSIGNEE_BOUNCE branch (ParticipantDialog.tsx),
// resolved at collection time instead of render time — see the `title`
// field comment on `AssigneeBounceErrorData` for the TASK-bounce quirk.
const resolveAssigneeBounceTitle = (
  tpl: Doc<IExperienceTemplate>,
  instance: Doc<IExperience>,
  itemType: 'MESSAGE' | 'TASK',
  itemTplId: string
): string => {
  const expTitle = tpl.data.title;
  if (itemType === 'MESSAGE') {
    const msgTpl = getMessageTemplateById(tpl, itemTplId);
    return msgTpl ? resolveExpTitle(getItemDisplayName(msgTpl), expTitle) : '';
  }
  const task = instance.data.tasks.find((t) => t.id === itemTplId);
  if (!task) return '';
  const taskTpl = getTaskTemplateById(tpl, task.templateId);
  return taskTpl ? resolveExpTitle(getItemDisplayName(taskTpl), expTitle) : '';
};

export const collectAssigneeBounceIssues = (
  tpl: Doc<IExperienceTemplate>,
  d: Doc<IExperience>
): AssigneeBounceErrorData[] => {
  return compact(
    d.data.instanceErrors.map((err): AssigneeBounceErrorData | null => {
      if (err.ignore) return null;
      if (err.type !== ErroDataType.ASSIGNEE_BOUNCED) return null;
      const e = err as AssigneeBouncedErrorData;
      return {
        type: 'ASSIGNEE_BOUNCE',
        email: e.email,
        displayName: e.displayName,
        bounceType: e.bounceType,
        itemType: e.itemType,
        itemTplId: e.itemTplId,
        title: resolveAssigneeBounceTitle(tpl, d, e.itemType, e.itemTplId),
        tpl,
        instance: d,
        id: e.id,
        at: e.at
      };
    })
  );
};
